import { Box, Flex } from '@modusign/design-system';
import { useHistory } from 'react-router-dom';

import Header from '@app/components/Header';
import LightHelpButton from '@app/components/HelpButton/LightHelpButton';
import ModusignIcon from '@app/components/Icons/ModusignIcon';

export default function InPersonPageHeader() {
  const history = useHistory();

  const handleExitClick = () => {
    history.push('/documents');
  };

  return (
    <Header minHeight={['54px', null, '65px']}>
      <Flex alignItems="center" flex={['none', null, 1]} justifyContent="flex-start">
        <Box
          alignItems="center"
          as="button"
          display="flex"
          ml={7}
          my="auto"
          onClick={handleExitClick}
        >
          <ModusignIcon />
        </Box>
      </Flex>
      <Flex alignItems="center" display={['none', null, 'flex']} flex={1} justifyContent="flex-end">
        <Box mx={7} my="auto">
          <LightHelpButton />
        </Box>
      </Flex>
    </Header>
  );
}
